import FormattedMessage from 'I18n/components/FormattedMessage';
import { useUpdateAllowedEntityTypeAndIdsMutation } from '../../../__generated__/chirp/com/hubspot/applications/governance/rpc/ApplicationGovernanceAppAuthRpc.hooks';
import { GET_APP_GOVERNANCE_PERMISSIONS_QUERY } from '../../../__generated__/chirp/com/hubspot/applications/governance/rpc/ApplicationGovernanceAppAuthRpc.dfc.new';
import { useApp } from '../../contexts/AppContext';
import { useCaptureError } from '../useCaptureError';
import { jsx as _jsx } from "react/jsx-runtime";
export function useUpdateAllowedEntityTypeAndIds() {
  const {
    appId
  } = useApp();
  const [updateAllowedEntityTypeAndIds, {
    loading,
    error
  }] = useUpdateAllowedEntityTypeAndIdsMutation({
    update: (cache, {
      data
    }) => {
      if (!data) {
        return;
      }
      const existingData = cache.readQuery({
        query: GET_APP_GOVERNANCE_PERMISSIONS_QUERY,
        variables: {
          appId
        }
      });
      if (!existingData) {
        return;
      }
      cache.writeQuery({
        query: GET_APP_GOVERNANCE_PERMISSIONS_QUERY,
        variables: {
          appId
        },
        data: Object.assign({}, existingData, {
          result: Object.assign({}, existingData.result, {
            installPermissionAccessState: data.result.installPermissionAccessState,
            entityTypeAndIds: data.result.entityTypeAndIds
          })
        })
      });
    }
  });
  useCaptureError(error, {
    message: 'Error updating install permissions',
    alert: {
      titleText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "app-governance-lib.errorBoundary.default.title"
      }),
      message: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "app-governance-lib.installPermissions.saveChanges.error"
      })
    }
  });
  return {
    updateAllowedEntityTypeAndIds,
    loading,
    error
  };
}